import { SwipeableDrawer, Box, Typography } from "@mui/material";
import DrawerHeader from "./DrawerHeader";
import NavListPublic from "./NavListPublic";
import NavListAuthed from "./NavListAuthed";
import PwaInstallButton from "./PwaInstallButton";

export default function SidebarDrawer({
  open,
  onClose,
  isAuthed,
  isAdmin,
  username,
  publicPages,
  onNavigate,
  onLogout,
  onOpenLogin,
}) {
  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableBackdropTransition={false}
      disableDiscovery={false}
      ModalProps={{ keepMounted: true }}
      sx={{
        "& .MuiDrawer-paper": {
          width: 320,
          maxWidth: "86vw",
          maxHeight: "100dvh",
          color: "surfaces.onDark",
          border: "none",
          borderTopRightRadius: 20,
          borderBottomRightRadius: 20,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: (t) =>
            `linear-gradient(180deg, ${t.palette.surfaces.drawer} 0%, ${t.palette.surfaces.drawer} 55%, rgba(0,0,0,0.18) 100%), ${t.palette.surfaces.drawer}`,
          boxShadow:
            "0 12px 40px rgba(0,0,0,0.35), inset -1px 0 0 rgba(255,255,255,0.06)",
        },
      }}
    >
      <DrawerHeader
        isAuthed={isAuthed}
        username={username}
        onOpenLogin={onOpenLogin}
        onNavigate={onNavigate}
      />

      <Box
        role="navigation"
        aria-label="Sidomeny"
        sx={{
          flex: "1 1 auto",
          minHeight: 0,
          overflowY: "auto",
          overscrollBehavior: "contain",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "thin",
          scrollbarColor: (t) =>
            `${t.palette.accent?.main || t.palette.primary.main} transparent`,
          "&::-webkit-scrollbar": {
            width: 8,
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: 999,
            backgroundColor: (t) =>
              t.palette.accent?.main || t.palette.primary.main,
            border: "2px solid transparent",
            backgroundClip: "content-box",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: (t) =>
              t.palette.accent?.dark ||
              t.palette.accent?.main ||
              t.palette.primary.main,
          },
          pt: 1.5,
          pb: 2,
        }}
      >
        <SectionLabel>Utforska</SectionLabel>
        <NavListPublic pages={publicPages} onNavigate={onNavigate} />
        <SectionLabel sx={{ mt: 2 }}>App</SectionLabel>
        <PwaInstallButton onClose={onClose} />
        {isAuthed && (
          <>
            <SectionLabel sx={{ mt: 2 }}>Konto</SectionLabel>
            <NavListAuthed
              isAdmin={isAdmin}
              username={username}
              onNavigate={onNavigate}
              onLogout={onLogout}
              onClose={onClose}
            />
          </>
        )}
      </Box>
    </SwipeableDrawer>
  );
}

function SectionLabel({ children, sx }) {
  return (
    <Typography
      sx={{
        px: 3,
        mb: 0.5,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        color: "rgba(255,255,255,0.45)",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
